<template>
    <div class="ListItemDailyFunctionality">
      <v-row v-for="(item, index) in list" :key="index" class="ma-0 pa-0">
        <v-col class="ma-0 pa-0">
          <DailyFunctioalityItemApp :item="item"/>
          <v-divider></v-divider>
        </v-col>
      </v-row>
    </div>
    
 
</template>

<script>
import DailyFunctioalityItemApp from './DailyFunctioalityItemApp.vue'
export default {
  components:{
    DailyFunctioalityItemApp,
    
  },
  props: {
    list: Array,
  },
  computed: {},
  data() {
    return {
      dailyList: [],
    };
  },
};
</script>

<style lang="scss">
.holiday {
  //border-right: 5px solid var(--border-green) !important;
  background-color: var(--background-green) !important;

  &:hover {
    background-color: var(--hover-green) !important;
  }
}

.normal {
  //border-right: 5px solid #f2f2f2 !important;
  background-color: #f2f2f2 !important;

  &:hover {
    background-color: #cecece !important;
  }
}
.absent {
  //border-right: 5px solid var(--border-red) !important;
  background-color: var(--background-red) !important;

  &:hover {
    background-color: var(--hover-red) !important;
  }
}
</style>